import { useEffect, useState } from "react";
import deathApi from "../../../../apis/death.api";

export default function useFetchContacts(setLoading) {
  const [contactList, setContactList] = useState([]);

  useEffect(() => {
    getContactsModule();
  }, []);
  const getContactsModule = async () => {
    try {
      setLoading(true);
      setContactList([]);
      const apiResponse = await deathApi.getClientContacts();
      console.log("apiResponse", apiResponse);

      if (apiResponse && apiResponse.data) {
        const processedContacts = apiResponse.data.map((contact) => {
          // Trim and handle null/undefined values
          const firstName = (contact.firstName && contact.firstName.trim()) || "";
          const lastName = (contact.lastName && contact.lastName.trim()) || "";
          const phoneNumber = (contact.phoneNumber && contact.phoneNumber.trim()) || "";

          // Create full name only if at least firstName exists
          let fullName = "";
          if (firstName && lastName) {
            fullName = `${firstName} ${lastName}`;
          } else if (firstName) {
            fullName = firstName;
          } else if (lastName) {
            fullName = lastName;
          } else {
            fullName = (contact.name && contact.name.trim()) || ""; // Fallback to name field
          }

          // Return the full contact object with the calculated fullName
          return {
            value: contact.id || Math.random().toString(36).substr(2, 9), // For <option value=...>
            label: fullName.trim(), // For display in the dropdown
          };
        });

        setContactList(processedContacts);
      }
      setLoading(false);
    } catch (error) {
      console.error("Failed to load contacts:", error);
      setLoading(false);
    }
  };
  return { contactList };
}
